export default __webpack_public_path__ + "static/smart-segment-optimized-cdc6a5919fa0b2eca0eb928011d9ee8a.jpg";